const almas_address = `
    <span class="about-heading">Legal Name</span>
    <p>Al Madeena Institute Of Medical Science Private Limited</p>
    <span class="about-heading">Address</span>
    <p>Al Madeena Institute Of Medical Science Private Limited,
    Changuvetty malappuram kerala 676503</p>
`;
export default almas_address;